import { NumberMode } from '@coast/schemas';
import { NumberFormat } from '@shared/scenes/workflows/config';

export function parseNumber(value: string, numberMode: NumberMode | NumberFormat): number {
  const mode = numberMode.toLowerCase();
  const valueWithoutCommas = value.replace(/[,]/g, '');
  if (mode === 'currency') {
    return Number(valueWithoutCommas.replace(/^[$]/, ''));
  }
  if (mode === 'percent') {
    const match = valueWithoutCommas.match(/^(.*)[%]$/);
    if (!match) {
      return Number(valueWithoutCommas);
    }
    // 10% => 0.1
    return Number(match[1]) / 100;
  }
  return Number(valueWithoutCommas);
}

export function formatNumber(
  value: number,
  numberMode: NumberMode | NumberFormat,
  showZeroDigitsIfRound?: boolean,
): string {
  switch (numberMode.toLowerCase()) {
    case 'float':
      return new Intl.NumberFormat().format(value);
    case 'percent':
      return new Intl.NumberFormat(undefined, {
        style: 'percent',
        maximumFractionDigits: 3,
      }).format(value);
    case 'currency':
      const digits = showZeroDigitsIfRound && Math.round(value / 100) === value / 100 ? 0 : 2;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      }).format(value / 100);
    default:
      console.warn('Unknown number mode', numberMode);
      return value.toString();
  }
}
